import {ConnectorsMembersList} from './ConnectorsMembersList';
import {TeamMembersPage} from './TeamMembersPage';
import {MembersPageTabs} from './types';

export const TeamConnectorsMembersPage = () => {
  return <TeamMembersPage activeTab={MembersPageTabs.Connectors} ListComponent={ConnectorsMembersList} />;
};
